function initGiftcardForm() {

    let quantityInput = document.getElementById('AddProductForm_Form_Quantity');
    let amountInput = document.getElementById('AddProductForm_Form_UnitPrice');
    if  (quantityInput && amountInput){
        quantityInput.type = 'number';
        amountInput.type = 'number';
    }
}

export default initGiftcardForm;
